module.exports = __webpack_public_path__ + "img/sixpackcarrier39.97beae25.jpg";